import { C_ACTION } from '../constans';

let new_state;
export const price = (state = {}, action) => {
  switch (action.type) {
    case C_ACTION.INIT: {
      return { ...action.state };
    }
    case C_ACTION.ADD: {
      return { ...state, [action.data.id]: { ...action.data } };
    }
    case C_ACTION.CHANGE: {
      return { ...state, [action.data.id]: { ...state[action.data.id], ...action.data } };
    }
    case C_ACTION.DELETE: {
      new_state = [...state];
      delete new_state[action.id];
      return { ...new_state };
    }
    case C_ACTION.CHANGE_PRODUCT_PROVIDER: {
      return {
        ...state,
        [action.id_product]: {
          ...state[action.id_product],
          ...action.item,
          providerId: action.provider.providerId,
          provider_name: action.provider.name,
        },
      };
    }

    case C_ACTION.CHANGE_PRODUCT_CATEGORY: {
      return {
        ...state,
        [action.id_product]: {
          ...state[action.id_product],
          ...action.item,
          category: action.category,
        },
      };
    }

    case C_ACTION.CHANGE_PRODUCT_SKU: {
      return {
        ...state,
        [action.id_product]: {
          ...state[action.id_product],
          ...action.item,
          sku: action.sku,
        },
      };
    }
    case C_ACTION.CHANGE_PRODUCT_NUM: {
      return {
        ...state,
        [action.id_product]: {
          ...state[action.id_product],
          ...action.item,
          quantity: action.quantity,
        },
      };
    }

    case C_ACTION.CHANGE_PRODUCT_SKU_QUANTITY: {
      return {
        ...state,
        [action.id_product]: {
          ...state[action.id_product],
          ...action.item,
          quantity: action.quantity,
          sku: action.sku,
        },
      };
    }
    default:
      return state;
  }
};
